var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{staticClass:"gl-shrink-0",attrs:{"variant":_vm.badgeProperties.variant,"icon":_vm.badgeProperties.icon,"aria-label":_vm.badgeProperties.text}},[_vm._v("\n  "+_vm._s(_vm.badgeProperties.text)+"\n")])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }